import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { environment } from 'src/environments/environment';

@Injectable()
export class DebugService {
    
    private _enabled:boolean = false;
    private _version:string = "0.0.0 (000)"
    
    /**
     * Constructor
     */
    constructor(
        private http: HttpClient,
    ) {}

    /**
     * Init
     */
    init(isAdmin:boolean = false, isDebug:boolean = false) {
        // this._enabled = environment.debug || isAdmin || isDebug;
        this._enabled = isDebug;

        fetch('assets/version.json')
            .then(response=>response.json())
            .then(data=>{ this._version = data.current })

        Network.addListener('networkStatusChange', status => {
            this.send('Network status changed: ' + status.connected);
        });
              
    }

    /**
     * Send debug data to backend
     */
    send(message: string, force: boolean = false, callback:Function = null) {
        if (this._enabled || force) {
            environment.debug && console.log(message);
            this.http.post<any>(
                `${environment.apiUrl}/deboug_messages`,
                { content: message, version: this._version, date: new Date(), milliseconds: (new Date().getTime()).toString()},
                { withCredentials: true }
            ).subscribe(_ => {
                if (callback) {
                    callback();
                }
            });
        }
    }

    /**
     * Destroy
     */
    destroy() {
        this._enabled = false;
    }
}
